"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.find");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _toConsumableArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/toConsumableArray.js"));

require("core-js/modules/es7.string.pad-start");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/web.dom.iterable");

var _installTask = require("@/api/cms/installTask");

var _installPower = require("@/api/cms/installPower");

var _multiUserSelect = _interopRequireDefault(require("@/views/cms/common/multiUserSelect"));

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'InstallCreate',
  components: {
    UserSelect: _multiUserSelect.default
  },
  dicts: ['delivery_install_time_slot'],
  data: function data() {
    return {
      screenHeight: document.documentElement.clientHeight || document.body.clientHeight,
      editId: null,
      isEdit: false,
      tableLoading: false,
      contractList: [],
      checkedContracts: [],
      uncheckedDesignSchemeIds: [],
      uncheckedOrderSolutionIds: [],
      isSubmitting: false,
      mapDialogVisible: false,
      searchKeyword: '',
      searchResults: [],
      showSearchResults: false,
      map: null,
      marker: null,
      tempCoordinate: '',
      installerLoading: false,
      installerSearchDate: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      scheduleList: [],
      scheduleTotal: 0,
      schedulePagination: {
        page: 1,
        pageSize: 10
      },
      showUserSelect: false,
      currentSelectTarget: '',
      installGroupName: '',
      installGroupUserId: '',
      installManagerName: '',
      installManagerUserId: '',
      installPersonName: '',
      installPersonUserId: '',
      form: {
        installCode: '',
        customer: '',
        customerPhone: '',
        customerAddress: '',
        coordinate: '',
        productType: '',
        isIn: null,
        installDate: '',
        installTime: '',
        installMamager: '',
        installGroup: '',
        installPerson: '',
        installPersonUserId: '',
        openWay: '',
        openRemark: '',
        remark: ''
      },
      rules: {
        customer: [{
          required: true,
          message: '请输入收货人',
          trigger: 'blur'
        }],
        customerPhone: [{
          required: true,
          message: '请输入收货人电话',
          trigger: 'blur'
        }],
        customerAddress: [{
          required: true,
          message: '请输入收货地址',
          trigger: 'blur'
        }],
        coordinate: [{
          required: true,
          message: '请输入定位坐标',
          trigger: 'blur'
        }],
        installDate: [{
          required: true,
          message: '请选择上门日期',
          trigger: 'change'
        }],
        installTime: [{
          required: true,
          message: '请选择上门时间',
          trigger: 'change'
        }],
        installMamager: [{
          required: true,
          message: '请选择安装主管',
          trigger: 'change'
        }],
        installGroup: [{
          required: true,
          message: '请选择安装组长',
          trigger: 'change'
        }],
        installPerson: [{
          required: true,
          message: '请选择安装师傅',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    amapApi: function amapApi() {
      return this.$store.state.api.amapApi;
    },
    amapSecurityJsCode: function amapSecurityJsCode() {
      return this.$store.state.api.amapSecurityJsCode;
    },
    tableHeight: function tableHeight() {
      return this.screenHeight * 0.45;
    },
    scheduleDateRange: function scheduleDateRange() {
      var base = this.installerSearchDate || this.getToday();
      var dates = [];
      var start = new Date(base);

      for (var i = 0; i < 7; i++) {
        var d = new Date(start);
        d.setDate(d.getDate() + i);
        var key = this.formatDate(d);
        dates.push({
          key: key,
          label: key
        });
      }

      return dates;
    },
    pagedScheduleList: function pagedScheduleList() {
      var start = (this.schedulePagination.page - 1) * this.schedulePagination.pageSize;
      return this.scheduleList.slice(start, start + this.schedulePagination.pageSize);
    },
    allOrderSolutions: function allOrderSolutions() {
      var result = [];
      this.contractList.forEach(function (contract) {
        if (contract.designSchemes) {
          contract.designSchemes.forEach(function (scheme) {
            if (scheme.orderSolutions) {
              scheme.orderSolutions.forEach(function (solution) {
                result.push(solution);
              });
            }
          });
        }
      });
      return result;
    },
    allDesignSchemes: function allDesignSchemes() {
      var result = [];
      this.contractList.forEach(function (contract) {
        if (contract.designSchemes) {
          contract.designSchemes.forEach(function (scheme) {
            result.push(scheme);
          });
        }
      });
      return result;
    },
    checkedDesignSchemes: function checkedDesignSchemes() {
      var uncheckedIds = new Set(this.uncheckedDesignSchemeIds);
      return this.allDesignSchemes.filter(function (s) {
        return !uncheckedIds.has(s.id);
      });
    },
    checkedOrderSolutions: function checkedOrderSolutions() {
      var uncheckedIds = new Set(this.uncheckedOrderSolutionIds);
      return this.allOrderSolutions.filter(function (s) {
        return !uncheckedIds.has(s.id);
      });
    },
    totalPackages: function totalPackages() {
      return this.checkedOrderSolutions.reduce(function (sum, s) {
        return sum + (parseInt(s.packages) || 0);
      }, 0);
    },
    totalArea: function totalArea() {
      return this.checkedOrderSolutions.reduce(function (sum, s) {
        var area = parseFloat(s.area);
        if (area) return sum + area;
        return sum;
      }, 0);
    }
  },
  mounted: function mounted() {
    this._firstActivated = true;
    this.initPage();
    window.addEventListener('resize', this.handleResize);
  },
  activated: function activated() {
    if (this._firstActivated) {
      this._firstActivated = false;
      return;
    }

    this.initPage();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    initPage: function initPage() {
      this.editId = this.$route.query.editId || null;
      this.isEdit = !!this.editId;

      if (this.isEdit) {
        sessionStorage.removeItem('install_contractList');
        this.initEditMode();
        return;
      }

      sessionStorage.removeItem('install_editData');
      this.resetCreateState();
      this.loadOrderData();
      this.loadInstallerList();
      this.generateInstallNo();
    },
    resetCreateState: function resetCreateState() {
      var _this = this;

      this.form = {
        installCode: '',
        customer: '',
        customerPhone: '',
        customerAddress: '',
        coordinate: '',
        productType: '',
        isIn: null,
        installDate: '',
        installTime: '',
        installMamager: '',
        installGroup: '',
        installPerson: '',
        installPersonUserId: '',
        openWay: '',
        openRemark: '',
        remark: ''
      };
      this.contractList = [];
      this.checkedContracts = [];
      this.uncheckedDesignSchemeIds = [];
      this.uncheckedOrderSolutionIds = [];
      this.installGroupName = '';
      this.installGroupUserId = '';
      this.installManagerName = '';
      this.installManagerUserId = '';
      this.installPersonName = '';
      this.installPersonUserId = '';
      this.tableLoading = false;
      this.$nextTick(function () {
        if (_this.$refs.form) {
          _this.$refs.form.clearValidate();
        }
      });
    },
    handleResize: function handleResize() {
      this.screenHeight = document.documentElement.clientHeight || document.body.clientHeight;
    },
    getStatusTagType: function getStatusTagType(status) {
      var statusMap = {
        '待签单': 'warning',
        '已签单': 'success',
        '待分配设计师': 'warning',
        '待测量': 'warning',
        '待复尺': 'warning',
        '待确认设计方案': 'warning',
        '待下单': 'warning',
        '已下单': 'primary',
        '待处理': 'warning',
        '已发货': 'primary',
        '已安装': 'success',
        '已完成': 'success',
        '待审核': 'info',
        '被退回': 'danger',
        '待付款': 'warning',
        '待入库': 'primary',
        '齐套待预约': 'primary',
        '待发货': 'info',
        '不齐套发货': 'warning',
        '售后中': 'danger'
      };
      return statusMap[status] || 'info';
    },
    getDesignSchemeTotalPackages: function getDesignSchemeTotalPackages(ds) {
      if (!ds.orderSolutions || ds.orderSolutions.length === 0) return 0;
      return ds.orderSolutions.reduce(function (sum, os) {
        return sum + (os.packages || 0);
      }, 0);
    },
    getContractTotalPackages: function getContractTotalPackages(row) {
      var _this2 = this;

      if (!row.designSchemes || row.designSchemes.length === 0) return 0;
      return row.designSchemes.reduce(function (sum, ds) {
        return sum + _this2.getDesignSchemeTotalPackages(ds);
      }, 0);
    },
    getContractTotalArea: function getContractTotalArea(row) {
      if (!row.designSchemes || row.designSchemes.length === 0) return 0;
      return row.designSchemes.reduce(function (sum, ds) {
        if (!ds.orderSolutions || ds.orderSolutions.length === 0) return sum;
        return sum + ds.orderSolutions.reduce(function (s, os) {
          return s + (parseFloat(os.area) || 0);
        }, 0);
      }, 0);
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return '';
      var d = new Date(dateStr);
      var year = d.getFullYear();
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    },
    generateInstallNo: function generateInstallNo() {
      var _this3 = this;

      if (this.isEdit) return;
      (0, _installTask.getInstallTaskNumber)().then(function (res) {
        if (res && res.data) {
          _this3.form.installCode = res.data;
        }
      }).catch(function () {
        var now = new Date();
        var year = now.getFullYear();
        var month = String(now.getMonth() + 1).padStart(2, '0');
        var day = String(now.getDate()).padStart(2, '0');
        var random = String(Math.floor(Math.random() * 10000)).padStart(4, '0');
        _this3.form.installCode = "AZ".concat(year).concat(month).concat(day).concat(random);
      });
    },
    loadOrderData: function loadOrderData() {
      var _this4 = this;

      if (this.isEdit) return;
      var cachedData = sessionStorage.getItem('install_contractList');

      if (cachedData) {
        try {
          this.contractList = JSON.parse(cachedData) || [];
          this.checkedContracts = (0, _toConsumableArray2.default)(this.contractList);
          this.uncheckedDesignSchemeIds = [];
          this.uncheckedOrderSolutionIds = [];
          this.updateCustomerInfo();
          this.$nextTick(function () {
            if (_this4.$refs.contractTable) {
              _this4.contractList.forEach(function (contract) {
                _this4.$refs.contractTable.toggleRowSelection(contract, true);
              });
            }
          });
          this.tableLoading = false;
          return;
        } catch (e) {
          console.error('解析缓存数据失败:', e);
        }
      }

      this.contractList = [];
      this.tableLoading = false;
    },
    initEditMode: function initEditMode() {
      var _this5 = this;

      this.isEdit = true;
      this.tableLoading = true;
      var cachedData = sessionStorage.getItem('install_editData');

      if (!cachedData) {
        this.$message.error('未找到编辑数据');
        this.$router.push('/cms/install');
        return;
      }

      try {
        var row = JSON.parse(cachedData);
        this.form.installCode = row.installCode || '';
        this.form.customer = row.customer || '';
        this.form.customerPhone = row.customerPhone || '';
        this.form.customerAddress = row.customerAddress || '';
        this.form.coordinate = row.coordinateX != null && row.coordinateY != null ? "".concat(row.coordinateX, ", ").concat(row.coordinateY) : row.positioning || '';
        this.form.productType = row.productType || '';
        this.form.isIn = row.isIn != null ? row.isIn : null;
        this.form.installDate = row.installDate || '';
        this.form.installTime = row.installTime || '';
        this.form.installMamager = row.installMamager || '';
        this.form.installGroup = row.installGroup || '';
        this.installManagerName = row.installMamager || '';
        this.installGroupName = row.installGroup || '';
        this.form.installPerson = row.installPerson || '';
        this.form.installPersonUserId = row.installPersonUserId || '';
        this.installPersonName = row.installPerson || '';
        this.installPersonUserId = row.installPersonUserId || '';
        this.form.openWay = row.openWay || '';
        this.form.openRemark = row.openRemark || '';
        this.form.remark = row.remark || '';
        this.contractList = (row.contractList || []).map(function (contract) {
          return _objectSpread(_objectSpread({}, contract), {}, {
            contractId: contract.contractId || contract.id || '',
            contractNumber: contract.contractNo || contract.contractNumber || '',
            custName: contract.contactPerson || contract.custName || '',
            custMobile: contract.contactNumber || contract.custMobile || '',
            custAddress: contract.contactAddress || contract.custAddress || '',
            status: contract.contractStatusEnumeration || contract.status || ''
          });
        });
        this.checkedContracts = (0, _toConsumableArray2.default)(this.contractList);
        this.uncheckedDesignSchemeIds = [];
        this.uncheckedOrderSolutionIds = [];
        this.tableLoading = false;
        this.$nextTick(function () {
          if (_this5.$refs.contractTable) {
            _this5.contractList.forEach(function (contract) {
              _this5.$refs.contractTable.toggleRowSelection(contract, true);
            });
          }
        });
      } catch (e) {
        console.error('编辑数据解析失败:', e);
        this.$message.error('编辑数据解析失败');
        this.$router.push('/cms/install');
      }

      this.installerSearchDate = this.form.installDate || this.getToday();
      this.loadInstallerList();
    },
    updateCustomerInfo: function updateCustomerInfo() {
      var firstContract = this.contractList[0];

      if (firstContract) {
        this.form.customer = firstContract.custName || '';
        this.form.customerPhone = firstContract.custMobile || '';
        this.form.customerAddress = firstContract.custAddress || '';
      }
    },
    handleMainRowClick: function handleMainRowClick(row) {
      this.$refs.contractTable.toggleRowExpansion(row);
    },
    handleContractMainSelectionChange: function handleContractMainSelectionChange(selection) {
      var _this6 = this;

      var currentChecked = selection.map(function (item) {
        return item.contractId;
      });
      var previousChecked = this.checkedContracts.map(function (item) {
        return item.contractId;
      });
      var newlyChecked = currentChecked.filter(function (id) {
        return !previousChecked.includes(id);
      });
      var unchecked = previousChecked.filter(function (id) {
        return !currentChecked.includes(id);
      });

      if (newlyChecked.length > 0) {
        newlyChecked.forEach(function (contractId) {
          var contract = _this6.contractList.find(function (c) {
            return c.contractId === contractId;
          });

          if (contract && contract.designSchemes) {
            contract.designSchemes.forEach(function (scheme) {
              _this6.uncheckedDesignSchemeIds = _this6.uncheckedDesignSchemeIds.filter(function (id) {
                return id !== scheme.id;
              });

              if (scheme.orderSolutions) {
                scheme.orderSolutions.forEach(function (solution) {
                  _this6.uncheckedOrderSolutionIds = _this6.uncheckedOrderSolutionIds.filter(function (id) {
                    return id !== solution.id;
                  });
                });
              }
            });

            _this6.$nextTick(function () {
              var designSchemeTable = _this6.$refs['designSchemeTable_' + contractId];

              if (designSchemeTable) {
                var table = Array.isArray(designSchemeTable) ? designSchemeTable[0] : designSchemeTable;

                if (table) {
                  contract.designSchemes.forEach(function (s) {
                    table.toggleRowSelection(s, true);
                  });
                }
              }

              contract.designSchemes.forEach(function (scheme) {
                var solutionTable = _this6.$refs['orderSolutionTable_' + scheme.id];

                if (solutionTable) {
                  var st = Array.isArray(solutionTable) ? solutionTable[0] : solutionTable;

                  if (st && scheme.orderSolutions) {
                    scheme.orderSolutions.forEach(function (sol) {
                      st.toggleRowSelection(sol, true);
                    });
                  }
                }
              });
            });
          }
        });
      }

      if (unchecked.length > 0) {
        unchecked.forEach(function (contractId) {
          var contract = _this6.contractList.find(function (c) {
            return c.contractId === contractId;
          });

          if (contract && contract.designSchemes) {
            contract.designSchemes.forEach(function (scheme) {
              if (!_this6.uncheckedDesignSchemeIds.includes(scheme.id)) {
                _this6.uncheckedDesignSchemeIds.push(scheme.id);
              }

              if (scheme.orderSolutions) {
                scheme.orderSolutions.forEach(function (solution) {
                  if (!_this6.uncheckedOrderSolutionIds.includes(solution.id)) {
                    _this6.uncheckedOrderSolutionIds.push(solution.id);
                  }
                });
              }
            });

            _this6.$nextTick(function () {
              var designSchemeTable = _this6.$refs['designSchemeTable_' + contractId];

              if (designSchemeTable) {
                var table = Array.isArray(designSchemeTable) ? designSchemeTable[0] : designSchemeTable;

                if (table) {
                  contract.designSchemes.forEach(function (s) {
                    table.toggleRowSelection(s, false);
                  });
                }
              }

              contract.designSchemes.forEach(function (scheme) {
                var solutionTable = _this6.$refs['orderSolutionTable_' + scheme.id];

                if (solutionTable) {
                  var st = Array.isArray(solutionTable) ? solutionTable[0] : solutionTable;

                  if (st && scheme.orderSolutions) {
                    scheme.orderSolutions.forEach(function (sol) {
                      st.toggleRowSelection(sol, false);
                    });
                  }
                }
              });
            });
          }
        });
      }

      this.checkedContracts = selection;
    },
    handleDesignSchemeSelectionChange: function handleDesignSchemeSelectionChange() {
      var _this7 = this;

      this.$nextTick(function () {
        _this7.syncUncheckedDesignSchemes();
      });
    },
    handleDesignSchemeRowClick: function handleDesignSchemeRowClick(row) {
      var contractId = row._contractId;

      if (contractId) {
        var designSchemeTable = this.$refs['designSchemeTable_' + contractId];

        if (designSchemeTable) {
          var table = Array.isArray(designSchemeTable) ? designSchemeTable[0] : designSchemeTable;

          if (table) {
            table.toggleRowExpansion(row);
          }
        }
      }
    },
    handleDesignSchemeExpandChange: function handleDesignSchemeExpandChange(row, expandedRows) {
      var _this8 = this;

      if (expandedRows && expandedRows.length > 0) {
        this.$nextTick(function () {
          var solutionTable = _this8.$refs['orderSolutionTable_' + row.id];

          if (solutionTable) {
            var st = Array.isArray(solutionTable) ? solutionTable[0] : solutionTable;

            if (st && row.orderSolutions) {
              row.orderSolutions.forEach(function (solution) {
                var isUnchecked = _this8.uncheckedOrderSolutionIds.includes(solution.id);

                st.toggleRowSelection(solution, !isUnchecked);
              });
            }
          }
        });
      }
    },
    handleContractMainExpandChange: function handleContractMainExpandChange(row, expandedRows) {
      var _this9 = this;

      if (expandedRows && expandedRows.length > 0) {
        this.$nextTick(function () {
          var designSchemeTable = _this9.$refs['designSchemeTable_' + row.contractId];

          if (designSchemeTable) {
            var table = Array.isArray(designSchemeTable) ? designSchemeTable[0] : designSchemeTable;

            if (table && row.designSchemes) {
              row.designSchemes.forEach(function (scheme) {
                var isUnchecked = _this9.uncheckedDesignSchemeIds.includes(scheme.id);

                table.toggleRowSelection(scheme, !isUnchecked);
              });
            }
          }
        });
      }
    },
    handleOrderSolutionSelectionChange: function handleOrderSolutionSelectionChange() {
      var _this10 = this;

      this.$nextTick(function () {
        _this10.syncUncheckedOrderSolutions();
      });
    },
    syncUncheckedDesignSchemes: function syncUncheckedDesignSchemes() {
      var _this11 = this;

      this.contractList.forEach(function (contract) {
        if (contract.designSchemes) {
          var designSchemeTable = _this11.$refs['designSchemeTable_' + contract.contractId];

          if (designSchemeTable) {
            var table = Array.isArray(designSchemeTable) ? designSchemeTable[0] : designSchemeTable;

            if (table) {
              contract.designSchemes.forEach(function (scheme) {
                var isSelected = table.store.states.selection.some(function (s) {
                  return s.id === scheme.id;
                });

                if (!isSelected && !_this11.uncheckedDesignSchemeIds.includes(scheme.id)) {
                  _this11.uncheckedDesignSchemeIds.push(scheme.id);

                  if (scheme.orderSolutions) {
                    scheme.orderSolutions.forEach(function (solution) {
                      if (!_this11.uncheckedOrderSolutionIds.includes(solution.id)) {
                        _this11.uncheckedOrderSolutionIds.push(solution.id);
                      }
                    });
                  }
                } else if (isSelected) {
                  _this11.uncheckedDesignSchemeIds = _this11.uncheckedDesignSchemeIds.filter(function (id) {
                    return id !== scheme.id;
                  });

                  if (scheme.orderSolutions) {
                    scheme.orderSolutions.forEach(function (solution) {
                      _this11.uncheckedOrderSolutionIds = _this11.uncheckedOrderSolutionIds.filter(function (id) {
                        return id !== solution.id;
                      });
                    });
                  }
                }
              });
            }
          }
        }
      });
    },
    syncUncheckedOrderSolutions: function syncUncheckedOrderSolutions() {
      var _this12 = this;

      this.contractList.forEach(function (contract) {
        if (contract.designSchemes) {
          contract.designSchemes.forEach(function (scheme) {
            var solutionTable = _this12.$refs['orderSolutionTable_' + scheme.id];

            if (solutionTable) {
              var st = Array.isArray(solutionTable) ? solutionTable[0] : solutionTable;

              if (st && scheme.orderSolutions) {
                scheme.orderSolutions.forEach(function (solution) {
                  var isSelected = st.store.states.selection.some(function (s) {
                    return s.id === solution.id;
                  });

                  if (!isSelected && !_this12.uncheckedOrderSolutionIds.includes(solution.id)) {
                    _this12.uncheckedOrderSolutionIds.push(solution.id);
                  } else if (isSelected) {
                    _this12.uncheckedOrderSolutionIds = _this12.uncheckedOrderSolutionIds.filter(function (id) {
                      return id !== solution.id;
                    });
                  }
                });
              }
            }
          });
        }
      });
    },
    getScheduleClass: function getScheduleClass(status) {
      if (status === '请假') return 'schedule-leave';
      if (status === '可用') return 'schedule-available';
      if (/^\d{2}:\d{2}-\d{2}:\d{2}(\s\|\s\d{2}:\d{2}-\d{2}:\d{2})*$/.test(status)) return 'schedule-task';
      return 'schedule-idle';
    },
    onSelectGroup: function onSelectGroup() {
      this.currentSelectTarget = 'group';
      this.$refs.userSelect.selectType = '安装';
      this.$refs.userSelect.nickNames = this.installGroupName ? [this.installGroupName] : [];
      this.$refs.userSelect.userNames = this.installGroupName ? [this.installGroupName] : [];
      this.$refs.userSelect.isFirst = true;
      this.showUserSelect = true;
      this.$refs.userSelect.getDeptDatas('安装');
    },
    onSelectManager: function onSelectManager() {
      this.currentSelectTarget = 'manager';
      this.$refs.userSelect.selectType = '安装';
      this.$refs.userSelect.nickNames = this.installManagerName ? [this.installManagerName] : [];
      this.$refs.userSelect.userNames = this.installManagerName ? [this.installManagerName] : [];
      this.$refs.userSelect.isFirst = true;
      this.showUserSelect = true;
      this.$refs.userSelect.getDeptDatas('安装');
    },
    onSelectPerson: function onSelectPerson() {
      this.currentSelectTarget = 'person';
      this.$refs.userSelect.selectType = '安装';
      this.$refs.userSelect.nickNames = [];
      this.$refs.userSelect.userNames = [];
      this.$refs.userSelect.isFirst = true;
      this.showUserSelect = true;
      this.$refs.userSelect.getDeptDatas('安装');
    },
    onSelectUserClose: function onSelectUserClose() {
      this.showUserSelect = false;
    },
    selectUserCallBack: function selectUserCallBack(user) {
      var selections = this.$refs.userSelect.crud.selections || [];
      var name = selections.length > 0 ? selections[0].nickName : user.nickNames.length > 0 ? user.nickNames[0] : '';
      var userId = selections.length > 0 ? selections[0].id : '';

      if (this.currentSelectTarget === 'group') {
        this.installGroupName = name;
        this.installGroupUserId = userId;
        this.form.installGroup = name;
      } else if (this.currentSelectTarget === 'manager') {
        this.installManagerName = name;
        this.installManagerUserId = userId;
        this.form.installMamager = name;
      } else if (this.currentSelectTarget === 'person') {
        var names = selections.map(function (s) {
          return s.nickName;
        }).join('、');
        var ids = selections.map(function (s) {
          return s.id;
        }).join(',');
        this.installPersonName = names;
        this.installPersonUserId = ids;
        this.form.installPerson = names;
        this.form.installPersonUserId = ids;
      }

      this.showUserSelect = false;
    },
    handleScheduleSizeChange: function handleScheduleSizeChange(val) {
      this.schedulePagination.pageSize = val;
    },
    handleScheduleCurrentChange: function handleScheduleCurrentChange(val) {
      this.schedulePagination.page = val;
    },
    handleSave: function handleSave(status) {
      var _this13 = this;

      if (this.isSubmitting) return;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this13.checkedOrderSolutions.length === 0) {
            _this13.$message.error('请至少选择一个订单方案');

            return;
          }

          var confirmMsg = status === 0 ? '确定要保存吗？' : _this13.isEdit ? '确定要更新安装工单吗？' : '确定要提交安装工单吗？';

          _this13.$confirm(confirmMsg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this13.isSubmitting = true;

            _this13.doSave(status);
          }).catch(function () {});
        }
      });
    },
    doSave: function doSave(status) {
      var _this14 = this;

      var solutionIds = this.checkedOrderSolutions.map(function (s) {
        return s.id;
      });
      var contractIds = [];
      var auditSolutionRelations = [];
      this.contractList.forEach(function (contract) {
        if (contract.designSchemes) {
          contract.designSchemes.forEach(function (scheme) {
            if (scheme.orderSolutions) {
              var selectedSolutionIds = scheme.orderSolutions.filter(function (s) {
                return solutionIds.includes(s.id);
              }).map(function (s) {
                return s.id;
              });

              if (selectedSolutionIds.length > 0) {
                auditSolutionRelations.push({
                  auditId: scheme.id,
                  orderSolutionIds: selectedSolutionIds
                });
              }

              var hasSelected = selectedSolutionIds.length > 0;

              if (hasSelected && !contractIds.includes(contract.contractId)) {
                contractIds.push(contract.contractId);
              }
            }
          });
        }
      });
      var submitData = {
        installCode: this.form.installCode,
        solutionIds: solutionIds,
        contractIds: contractIds,
        auditSolutionRelations: auditSolutionRelations,
        customer: this.form.customer,
        customerPhone: this.form.customerPhone,
        customerAddress: this.form.customerAddress,
        productType: this.form.productType,
        isIn: this.form.isIn,
        installDate: this.form.installDate,
        installTime: this.form.installTime,
        installMamager: this.form.installMamager,
        installGroup: this.form.installGroup,
        installPerson: this.form.installPerson,
        installPersonUserId: this.form.installPersonUserId,
        openWay: this.form.openWay,
        openRemark: this.form.openRemark,
        remark: this.form.remark,
        status: status
      };

      if (this.isEdit) {
        submitData.id = this.editId;
      }

      if (this.form.coordinate) {
        var coordStr = this.form.coordinate.replace(/[()]/g, '').trim();
        var coords = coordStr.split(',');
        submitData.coordinateX = coords[0] ? parseFloat(coords[0].trim()) : null;
        submitData.coordinateY = coords[1] ? parseFloat(coords[1].trim()) : null;
      }

      var apiCall = this.isEdit ? (0, _installTask.updateInstallTask)(submitData) : (0, _installTask.createInstallTask)(submitData);
      apiCall.then(function (response) {
        _this14.isSubmitting = false;

        if (response.code === 200) {
          var statusMsg = status === 0 ? '草稿保存成功' : _this14.isEdit ? '安装工单更新成功' : '安装工单创建成功';

          _this14.$message.success(statusMsg);

          sessionStorage.removeItem('install_editData');
          sessionStorage.removeItem('install_contractList');

          _this14.$store.dispatch('tagsView/delView', _this14.$route).then(function () {
            _this14.$router.push('/cms/install');
          });
        } else {
          _this14.$message.error(response.msg || '操作失败，请重试');
        }
      }).catch(function (error) {
        _this14.isSubmitting = false;
        console.error('操作失败:', error);

        _this14.$message.error('操作失败，请重试');
      });
    },
    loadInstallerList: function loadInstallerList(callback) {
      var _this15 = this;

      this.installerLoading = true;
      this.schedulePagination.page = 1;
      var params = {
        page: 0,
        size: 200
      };

      if (this.installerSearchDate) {
        params.createDate = this.installerSearchDate;
      }

      (0, _installPower.getInstallPowerSevenDay)(params).then(function (response) {
        if (response.code === 200) {
          _this15.buildScheduleData(response.data.content || []);
        }

        _this15.installerLoading = false;

        if (callback) {
          callback();
        }
      }).catch(function () {
        _this15.installerLoading = false;
      });
    },
    buildScheduleData: function buildScheduleData(data) {
      var _this16 = this;

      var scheduleData = [];
      data.forEach(function (user) {
        var row = {
          name: user.userName,
          userId: user.userId
        };
        var powers = user.powers || [];

        _this16.scheduleDateRange.forEach(function (dateItem) {
          var amKey = dateItem.key + '_上午';
          var pmKey = dateItem.key + '_下午';
          var amStatus = '空闲';
          var pmStatus = '空闲';
          var amInstallTimes = [];
          var pmInstallTimes = [];
          powers.forEach(function (power) {
            var powerDate = _this16.formatDate(power.taskDate);

            if (powerDate !== dateItem.key) return;
            var taskTime = power.taskTime || '';
            var tasks = power.tasks || [];
            tasks.forEach(function (task) {
              var installDate = _this16.formatDate(task.installDate);

              if (installDate === dateItem.key && task.installTime) {
                var startHour = parseInt(task.installTime.split(':')[0], 10);

                if (startHour < 12) {
                  amInstallTimes.push(task.installTime);
                } else {
                  pmInstallTimes.push(task.installTime);
                }
              }
            });

            if (power.status === 1) {
              if (taskTime.includes('上午') || taskTime.includes('08:00-12:00')) amStatus = '休息';
              if (taskTime.includes('下午') || taskTime.includes('12:00-18:00')) pmStatus = '休息';

              if (taskTime.includes('全天') || taskTime.includes('08:00-18:00')) {
                amStatus = '休息';
                pmStatus = '休息';
              }
            } else {
              if (taskTime.includes('上午') || taskTime.includes('08:00-12:00')) amStatus = '可用';
              if (taskTime.includes('下午') || taskTime.includes('12:00-18:00')) pmStatus = '可用';

              if (taskTime.includes('全天') || taskTime.includes('08:00-18:00')) {
                amStatus = '可用';
                pmStatus = '可用';
              }
            }
          });

          if (amInstallTimes.length > 0) {
            amStatus = amInstallTimes.join(' | ');
          }

          if (pmInstallTimes.length > 0) {
            pmStatus = pmInstallTimes.join(' | ');
          }

          row[amKey] = amStatus;
          row[pmKey] = pmStatus;
        });

        scheduleData.push(row);
      });
      this.scheduleList = scheduleData;
      this.scheduleTotal = scheduleData.length;
    },
    openMapSelector: function openMapSelector() {
      var _this17 = this;

      this.mapDialogVisible = true;
      this.$nextTick(function () {
        _this17.initMap();
      });
    },
    initMap: function initMap() {
      var _this18 = this;

      if (this.map) {
        this.map.destroy();
        this.map = null;
      }

      this.tempCoordinate = this.form.coordinate || '';

      var loadMapScript = function loadMapScript() {
        return new Promise(function (resolve, reject) {
          if (typeof window.AMap !== 'undefined') {
            resolve();
            return;
          }

          window._AMapSecurityConfig = {
            securityJsCode: _this18.amapSecurityJsCode
          };
          var callbackName = 'initAmapInstall_' + Date.now();

          window[callbackName] = function () {
            resolve();
            delete window[callbackName];
          };

          var script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = _this18.amapApi + '&callback=' + callbackName;
          script.async = true;
          script.defer = true;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      };

      loadMapScript().then(function () {
        _this18.createMap();
      }).catch(function () {
        _this18.$message.error('地图加载失败，请刷新页面重试');
      });
    },
    createMap: function createMap() {
      var _this19 = this;

      try {
        var center = [108.370859, 22.678838];

        if (this.form.coordinate) {
          var lnglatMatch = this.form.coordinate.match(/(\d+\.\d+),\s*(\d+\.\d+)/);

          if (lnglatMatch) {
            var lng = parseFloat(lnglatMatch[1]);
            var lat = parseFloat(lnglatMatch[2]);
            center = [lng, lat];
          }
        }

        this.map = new window.AMap.Map('mapContainer', {
          zoom: 14,
          center: center
        });
        window.AMap.plugin(['AMap.Scale', 'AMap.ToolBar'], function () {
          _this19.map.addControl(new window.AMap.Scale());

          _this19.map.addControl(new window.AMap.ToolBar());
        });
        this.marker = new window.AMap.Marker({
          position: center,
          draggable: true
        });
        this.map.add(this.marker);
        this.map.on('click', function (e) {
          _this19.tempCoordinate = "(".concat(e.lnglat.getLng(), ", ").concat(e.lnglat.getLat(), ")");

          _this19.marker.setPosition([e.lnglat.getLng(), e.lnglat.getLat()]);
        });
        this.marker.on('dragend', function () {
          var pos = _this19.marker.getPosition();

          _this19.tempCoordinate = "(".concat(pos.getLng(), ", ").concat(pos.getLat(), ")");
        });
      } catch (e) {
        console.error('地图初始化失败:', e);
        this.$message.error('地图初始化失败，请重试');
      }
    },
    handleSearchInput: function handleSearchInput() {
      if (!this.searchKeyword || this.searchKeyword.length < 2) {
        this.showSearchResults = false;
        return;
      }

      this.searchLocation();
    },
    searchLocation: function searchLocation() {
      var _this20 = this;

      if (!this.searchKeyword) return;

      if (this.map && window.AMap) {
        window.AMap.plugin('AMap.PlaceSearch', function () {
          var placeSearch = new window.AMap.PlaceSearch({
            city: '南宁',
            citylimit: false,
            pageSize: 10,
            pageIndex: 1
          });
          placeSearch.search(_this20.searchKeyword, function (status, result) {
            if (status === 'complete' && result.poiList) {
              _this20.searchResults = result.poiList.pois;
              _this20.showSearchResults = true;
            } else {
              _this20.searchResults = [];
              _this20.showSearchResults = false;
            }
          });
        });
      }
    },
    selectSearchResult: function selectSearchResult(result) {
      var lng = result.location.lng;
      var lat = result.location.lat;
      this.tempCoordinate = "(".concat(lng, ", ").concat(lat, ")");

      if (this.map) {
        this.map.setCenter([lng, lat]);
        this.marker.setPosition([lng, lat]);
      }

      this.showSearchResults = false;
      this.searchKeyword = result.name;
    },
    confirmMapSelection: function confirmMapSelection() {
      if (!this.tempCoordinate) {
        if (this.marker) {
          var pos = this.marker.getPosition();
          this.tempCoordinate = "(".concat(pos.getLng(), ", ").concat(pos.getLat(), ")");
        } else if (this.map) {
          var center = this.map.getCenter();
          this.tempCoordinate = "(".concat(center.getLng(), ", ").concat(center.getLat(), ")");
        }
      }

      if (this.tempCoordinate) {
        this.form.coordinate = this.tempCoordinate.replace(/[()]/g, '');
      }

      this.mapDialogVisible = false;
    },
    getToday: function getToday() {
      var date = new Date();
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    },
    goBack: function goBack() {
      sessionStorage.removeItem('install_editData');
      sessionStorage.removeItem('install_contractList');
      this.$router.push('/cms/install');
    }
  }
};
exports.default = _default;